/**
 * Maximum Allowed Upload File Size for RP Attachments
 *
 * Raw Value is 5428800 which is equivalent to 50 MB.
 * @type {number}
 */
export const MAXIMUM_ALLOWED_UPLOAD_RP_FILE_SIZE = 52428800

export const contentGroupKeyName = 'contentGroup'
export const reportTypeKeyName = 'type'
export const attachmentTypeKeyName = 'attachmentType'
export const internalAttachmentTypeKeyName = 'internalAttachmentType'

// File Validator Error Messages
export const RPFileValidatorErrorMessages = {
  FileIsTooBig: 'File is too big',
  FileTypeNotAllowed: 'File type not allowed',
  FileNameIsInvalid: 'File name is invalid',
  FileDuplicateExists: 'Duplicate file already exists',
  FileUploadOtherFile: 'Please upload other file.',
}

// File Validator Success Messages
export const RPFileValidatorSuccessMessage = {
  FileUploadedReadyToLink:
    'File has been uploaded successfully and ready to link in WB and ECM TIC.',
  FileUploadedSuccessful: 'File has been uploaded successfully.',
}

export enum RPAttachmentLinkButtonEnum {
  unlinkEcm = 0,
  linkToWb = 1,
  linkToWbAndEcm = 2,
}

export const UploadToEcmInProgressText = 'Uploading in progress'
export const UnlinkingToEcmInProgressText = 'Unlinking in progress'
export const UploadToBlobFailedText = 'Upload Failed'
export const LinkedToWbAndEcmTicText = 'Linked/Saved to WB & ECM TIC'
export const SavedInEcmTicText = 'Saved in ECM TIC'
export const ReadyToLinkToWbAndEcmTicText = 'Ready to Link/Save to WB & ECM TIC'
export const ReadyToReLinkToWbAndEcmTicText = 'Ready to Re-link/Save to WB & ECM TIC'
export const UnlinkEcmBtnText = 'Unlink File from WB'
export const LinkToWbAndEcmBtnText = 'Link File to WB and ECM TIC'
export const LinkToWbBtnText = 'Link File to WB'

export const displayUnlinkEcmModalHeader = 'Unlink File Confirmation'
export const displayLinkEcmModalHeader = 'Link File to WB and ECM TIC Confirmation'

export const TestReportDuplicateText = 'Link File to WB and ECM TIC'
export const TestReportDuplicateLinkToEcmFailedHover =
  'File already exists in ECM TIC. Please continue processing the linking of file.'
export const TestReportDuplicateLinkToEcmFailedText = 'Continue Linking Existing File from ECM TIC'
